jQuery(function ($) {
	// Pre-checkout login phone/OTP validation
	(function initPreCheckoutValidation() {
		const $scope = $('#pre-checkout-page');
		if (!$scope.length) return;

		const $phone = $scope.find('#login_phone');
		const $otp = $scope.find('.pre-check-verify-OTP-field');
		const $error = $scope.find('#errorsms_msg');

		const showError = (message) => {
			if (message) {
				$error.text(message).removeClass('d-none');
			} else {
				$error.text('').addClass('d-none');
			}
		};

		const sanitizeDigits = (value) => (value || '').replace(/\D/g, '');
		const isValidPhone = (value) => {
			const v = sanitizeDigits(value);
			return v.length >= 9 && v.length <= 10; // adjust if needed
		};
		const isValidOtp = (value) => {
			const v = sanitizeDigits(value);
			return v.length >= 4 && v.length <= 6; // common OTP length
		};

		// Phone input: keep digits only, validate live
		$phone.on('input', function () {
			const v = sanitizeDigits($(this).val());
			$(this).val(v);
			if (v.length && !isValidPhone(v) && v.length > 10) {
				showError("מספר הטלפון שהזנת לא תקין");
			} else {
				showError('');
			}
		});

		// On blur: show OTP field if phone valid
		// $phone.on('blur', function () {
		//     const v = $(this).val();
		//     if (!isValidPhone(v) || v.length !== 10) {
		//         showError("מספר הטלפון שהזנת לא תקין");
		//     } else {
		//         showError('');
		//     }
		// });

		// OTP input: digits only, validate live
		$otp.on('input', function () {
			const v = sanitizeDigits($(this).val());
			$(this).val(v);
			if (v.length || !isValidOtp(v)) {
				// showError('Invalid verification code asdsa');
			} else {
				showError('');
			}
		});

		// Block submit if invalid
		const $form = $scope.is('form') ? $scope : $scope.find('form').first();
		if ($form.length) {
			$form.on('submit', function (e) {
				const p = $phone.val();
				if (!isValidPhone(p) || p.length !== 10) {
					e.preventDefault();
					// showError("מספר הטלפון שהזנת לא תקין");
					$phone.focus();
					return false;
				}
				if ($otp.is(':visible')) {
					const o = $otp.val();
					if (!isValidOtp(o)) {
						e.preventDefault();
						showError('Please enter the verification code');
						$otp.focus();
						return false;
					}
				}
			});
		}
	})();

	(function myAccountValidation() {
		const $scope = $('.woocommerce-form-login');
		if (!$scope.length) return;

		const $phone = $scope.find('#user_phone');
		const $otp = $scope.find('#user_otp');
		const $error = $scope.find('#errorsms_msg');

		const showError = (message) => {
			if (message) {
				$error.text(message).removeClass('d-none');
			} else {
				$error.text('').addClass('d-none');
			}
		};

		const sanitizeDigits = (value) => (value || '').replace(/\D/g, '');
		const isValidPhone = (value) => {
			const v = sanitizeDigits(value);
			return v.length >= 9 && v.length <= 12; // adjust if needed
		};
		const isValidOtp = (value) => {
			const v = sanitizeDigits(value);
			return v.length >= 4 && v.length <= 6; // common OTP length
		};

		// Phone input: keep digits only, validate live
		$phone.on('input', function () {
			const v = sanitizeDigits($(this).val());
			$(this).val(v);
			if (v.length && !isValidPhone(v) && v.length > 12) {
				showError("מספר הטלפון שהזנת לא תקין");
			} else {
				showError('');
			}
		});

		// On blur: show OTP field if phone valid
		// $phone.on('blur', function () {
		//     const v = $(this).val();
		//     if (!isValidPhone(v) || v.length !== 10) {
		//         showError("מספר הטלפון שהזנת לא תקין");
		//     } else {
		//         showError('');
		//     }
		// });

		// OTP input: digits only, validate live
		$otp.on('input', function () {
			const v = sanitizeDigits($(this).val());
			$(this).val(v);
			if (v.length || !isValidOtp(v)) {
				// showError('Invalid verification code 99999');
			} else {
				showError('');
			}
		});

		// Block submit if invalid
		const $form = $scope.is('form') ? $scope : $scope.find('form').first();
		if ($form.length) {
			$form.on('submit', function (e) {
				const p = $phone.val();
				if (!isValidPhone(p) || p.length !== 10) {
					e.preventDefault();
					// showError("מספר הטלפון שהזנת לא תקין");
					$phone.focus();
					return false;
				}
				if ($otp.is(':visible')) {
					const o = $otp.val();
					if (!isValidOtp(o)) {
						e.preventDefault();
						showError('Please enter the verification code');
						$otp.focus();
						return false;
					}
				}
			});
		}
	})();

	$.extend($.validator.messages, {
		required: "השדה הזה הינו שדה חובה",
	});
});
